import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Divider from "@material-ui/core/Divider";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileContract } from '@fortawesome/free-solid-svg-icons';
import VillSkapa from './Inputs/VillSkapa'
import KopplaMed from './Inputs/KopplaMed'
import AvtatProTyp from './Inputs/AvtatProTyp'
import DateInput from './Inputs/DateInput'
import LopandeInput from './Inputs/LopandeInput'
import DocType from './Inputs/DocType'
import ImportFile from './Inputs/ImportFile'

import {Tabs ,Tab} from '@material-ui/core'
import PropTypes from 'prop-types';
import BefintligaDoc from './BefintligaDoc'
import { injectIntl } from 'react-intl';
import IntlMessages from 'util/IntlMessages';

const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(0),
            //   width: '28ch',
        },
    },
}));

function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          children
        )}
      </div>
    );
  }
  
  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
  };
  
  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

function Avtal(props) {
    const classes = useStyles();
    const ProspekttypLable = props.intl.formatMessage({ id: 'Prospectus.typ' });
    const ContracttypLable = props.intl.formatMessage({ id: 'Contract.type' });
    const DeadlineLable = props.intl.formatMessage({ id: 'Deadline' });
    const ApplytoLable = props.intl.formatMessage({ id: 'Apply.to' });
    const RenegotiationLable = props.intl.formatMessage({ id: 'Date.Renegotiation' });

    const [value, setValue] = React.useState(0);
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    return (
        <div>
           
            <div className={classes.root}>
                <div style={{ height: '64px', paddingTop: '15px' }} className="row">
                    <div className="col-6"  style={{ height: '64px' }}>
                       <VillSkapa
                       Value={props.Avtal.new}
                       onchangeHanelEvent={props.onchangeHanelAvtal}
                       />
                    </div>
                    <div className="col-6"  style={{ height: '64px' }}>
                        {
                            parseInt(props.Avtal.new) === 1?
                            <AvtatProTyp
                            title={ProspekttypLable}
                                Value={props.Avtal.typ}
                                onchangeHanelEvent={props.onchangeHanelAvtal} 
                            />:
                            parseInt(props.Avtal.new) === 2?
                            <AvtatProTyp
                            title={ContracttypLable}
                                Value={props.Avtal.typ}
                                onchangeHanelEvent={props.onchangeHanelAvtal} 
                            />:
                            parseInt(props.Avtal.new) === 3?
                            <KopplaMed
                                Value={props.Avtal.id}
                                onchangeHanelEvent={props.onchangeHanelAvtal} 
                            />:
                            ""
                        }
                    </div>
                </div>
                <div style={{ height: parseInt(props.Avtal.new)  === 2 ||parseInt(props.Avtal.new)  === 1?'64px':"auto", paddingTop: '15px' }} className="row">
                    
                    {
                        parseInt(props.Avtal.new) === 1?
                            <div className="col-4"  style={{ height: '64px' }}>
                                <DateInput
                                Value={props.Avtal.Gtill}
                                title={DeadlineLable}
                                Meta={"Gtill"}
                                onchangeHanelEvent={props.onchangeHanelAvtal} 
                                />
                            </div>:
                            parseInt(props.Avtal.new)  === 2?
                            <div className="col-4"  style={{ height: '64px' }}>
                                <LopandeInput
                                Value={props.Avtal.Lopande}
                                onchangeHanelEvent={props.onchangeHanelAvtal}
                                />
                            </div>:
                            parseInt(props.Avtal.new)  === 3?
                            "":
                            ""
                    }
                {
                    parseInt(props.Avtal.Lopande)  === 1?"":
                
                        parseInt(props.Avtal.new)  === 1?
                            "":
                            parseInt(props.Avtal.new)  === 2?
                                
                            <>
                                <div className="col-4"  style={{ height: '64px' }}>
                                <DateInput
                                Value={props.Avtal.Gtill}
                                title={ApplytoLable}
                                Meta={"Gtill"}
                                onchangeHanelEvent={props.onchangeHanelAvtal} 
                                />
                                </div>
                                <div className="col-4"  style={{ height: '64px' }}>
                                <DateInput
                                Value={props.Avtal.Omfor}
                                title={RenegotiationLable}
                                Meta={"Omfor"}
                                onchangeHanelEvent={props.onchangeHanelAvtal} 
                                />
                                </div>
                            </>:
                            parseInt(props.Avtal.new)  === 3?
                            "":
                            ""
                    
                }
                </div>
            </div>
            <div style={{ paddingTop: '15px', paddingBottom: '10px' }}>
                <Divider />
            </div>
            <div className={classes.root}>
                <div style={{ height: '64px', paddingTop: '15px' }} className="row">
                    <div className="col-12"  style={{ height: '64px' }}>
                        <DocType
                        Value={props.Document.Typ}
                        onchangeHanelEvent={props.onchangeHanelDocument}
                        />           
                    </div>
                </div>
                <div style={{ height: 'auto', paddingTop: '15px' }} className="row">
                    <div className="col-12"  style={{ height: 'auto' }}>
                    <Tabs
                    value={value}
                    indicatorColor="primary"
                    textColor="primary"
                    onChange={handleChange}
                    aria-label="disabled tabs example"
                    >
                        <Tab label={<IntlMessages id="Upload"/>} />
                        <Tab label={<IntlMessages id="isExisting"/>} />
                    </Tabs>
                    <TabPanel value={value} index={0}>
                        <ImportFile
                        isEsignering={1}
                        error={props.errorFile}
                        Value={props.Document.file}
                        onchangeHanelEvent={props.onchangeHanelDocument}
                        />   
                        </TabPanel>
                    <TabPanel value={value} index={1}>
                        <BefintligaDoc
                        onChangeBefintlig={props.onChangeBefintlig}
                        Value={props.Document.fileUrl}
                        EsigneringOrgnr={props.EsigneringOrgnr}
                        />
                    </TabPanel>       
                    </div>
                </div>
            </div>
        </div>
    )
}
export default injectIntl(Avtal);